module.exports = __webpack_public_path__ + "static/media/logo2.7c653474.png";